import { render, staticRenderFns } from "./FlightsNav.vue?vue&type=template&id=6bbadaec&"
import script from "./FlightsNav.vue?vue&type=script&lang=js&"
export * from "./FlightsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports